const ERROR = {
    CODE_NOT_REGISTRATED: (code: string) =>
        `Verdikoden ${code} er ikke registrert hos oss. Vennligst prøv på nytt for å sjekke om du tastet feil kode, eller kontakt oss.`,
    EXPIRED:
        "Denne verdikoden er gått ut på dato. Vennligst prøv på nytt for å sjekke om du tastet feil kode, eller kontakt oss.",
    VOUCHER_AMOUNT_IS_ZERO:
        "Verdikoden er allerede brukt, og har ikke noe mer verdi. Vennligst prøv på nytt for å sjekke om du tastet feil kode, eller kontakt oss.",
    VOUCHER_ALREADY_ADDED:
        "Verdikoden er allerede lagt inn og skal nå være brukt i denne ordren såfremt den har et gjenstående beløp. Kontakt oss hvis du ikke forstår veien videre.",
    INVALID:
        "Denne verdikoden er ikke gyldig lengre. Vennligst prøv på nytt for å sjekke om du tastet feil kode, eller kontakt oss.",
    VOUCHER_TOO_MANY_ATTEMPTS:
        "Du har forsøkt å legge inn en verdikode for mange ganger. Dette er for din sikkerhet at vi ikke lar noen gjøre dette for mange ganger. Du må vente en del minutter før du kan prøve på nytt. Vennligst kontakt oss hvis du ikke får det til.",
    VOUCHER_CODE_ERROR:
        "Feil med inntastet verdikode. Vennligst prøv på nytt for å sjekke om du tastet feil kode, eller kontakt oss.",
    VOUCHER_CREATED:
        "Verdikoden er ikke klar til bruk enda. Sjekk hvilken informasjon du fikk sammen med verdikoden, eller kontakt oss hvis du har noen spørsmål.",
    VOUCHER_INACTIVE:
        "Verdikoden har gått ut på dato eller den er deaktivert. Vennligst prøv på nytt for å sjekke om du tastet feil kode, eller kontakt oss.",
    VOUCHER_MISSING: "Du har ikke lagt inn en verdikode enda. Vennligst legg inn en kode du vil bruke.",
    VOUCHER_DEFAULT_ERROR:
        "En feil har oppstått ved sjekk av verdikoden. Vennligst prøv på nytt for å sjekke om du tastet feil kode, eller kontakt oss hvis feilen vedvarer og at du mener den skal ha verdi.",
    DISCOUNT_ALREADY_USED:
        "Rabattkoden er allerede brukt. Vennligst prøv på nytt, eller kontakt oss om du mener dette er feil.",
    NOT_FOUND:
        "Verdikoden ble ikke funnet. Vennligst kontakt oss hvis du mener du har tastet riktig kode og at den fortsatt skal ha en verdi.",
    GENERAL_ERROR:
        "En feil har oppstått ved sjekk av verdikoden. Vennligst prøv på nytt for å sjekke om du tastet feil kode, eller kontakt oss hvis feilen vedvarer og at du mener den skal ha verdi.",
} as const;

const TEXT = {
    // we can give an longer logical description in top of the page -
    // so the following messages can be longer than the logical messages we are prompting next to the fields
    ERROR,
} as const;

export type ErrorType = keyof typeof ERROR;

export default TEXT;
